import { motion } from "framer-motion";

// Consistent scroll-in reveal used across all landing sections.
// Same duration/easing everywhere to avoid a "patchwork" feel.
export const Reveal = ({ children, delay = 0, y = 24, className, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export default Reveal;
